export const initDates = (today = false) => {
  const date = new Date();

  const firstDay = new Date(Date.now() - 86400000 * 30)
    .toISOString()
    .split("T")[0];
  const lastDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    today ? date.getDate() : date.getDate() - 1
  )
    .toISOString()
    .split("T")[0];
  return {
    initDate: firstDay,
    endDate: lastDay,
  };
};
export const getCurrentMonth = () => {
  return new Date().getMonth() + 1;
};

export const getToday = () => {
  let theDate = new Date();
  theDate.setHours(theDate.getHours() - 3);
  return theDate.toISOString().slice(0, -8);
};
